import React, { useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";
import { handleFilterChange } from "../../helpers";
import Search from "../../components/form/Search";
import useFetch from "../../hooks/useFetch";
import { scholarshipApplicationList } from "../../services/scholarshipService";
import Table from "../../components/elements/table/Table";
import dayjs from "dayjs";
import Modal from "../../components/elements/Modal";
import Button from "../../components/form/Button";
import Input from "../../components/form/Input";
import { statusText } from "../../util/Flag";
import ApplicationModalFront from "../../components/sections/front/Apply/modals/ApplicationModalFront";
import ApplicationDetails from "../../components/modalcontent/ApplicationDetails";
import SubmissionDetailsFront from "../../components/modalcontent/SubmissionDetailsFront";

function Applications() {
  const [keyword, setKeyword] = useState("");
  const [isViewDetails, setViewDetails] = useState({
    isOpen: false,
    data: null,
  });
  const [applicationModal, setApplicationModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 5,
    page: 1,
    sortQuery: "ordering",
  });
  const search = useDebounce(keyword, 300);

  const { data, error, isLoading, updateData, isFetching, refetch } = useFetch({
    dependencies: ["scholarshipView", filters, search],
    fetchFunction: async () => {
      //   const scholarshipId = {};
      //   filters?.scholarshipId?.forEach((item, i) => {
      //     scholarshipId[`scholarshipId[${i}]`] = item;
      //   });
      //   delete filters?.scholarshipId;

      const res = await scholarshipApplicationList({
        ...filters,
        ...(search && { keyword: search }),
        // ...(id ? { "scholarshipId[0]": [id] } : scholarshipId),
      });
      return res?.docs;
    },
  });
  const statusStyles = {
    Received_Under_Review: {
      base: "!bg-blue-100 !border-blue-100 !text-blue-700",
      hover: "hover:!bg-blue-200 hover:!border-blue-200",
    },
    Additional_Action_Required: {
      base: "!bg-yellow-100 !border-yellow-100 !text-yellow-700",
      hover: "hover:!bg-yellow-200 hover:!border-yellow-200",
    },
    Interview_Stage: {
      base: "!bg-cyan-100 !border-cyan-100 !text-cyan-700",
      hover: "hover:!bg-cyan-200 hover:!border-cyan-200",
    },
    Awarded: {
      base: "!bg-green-100 !border-green-100 !text-green-700",
      hover: "hover:!bg-green-200 hover:!border-green-200",
    },
    Draft: {
      base: "!bg-purple-100 !border-purple-100 !text-purple-700",
      hover: "hover:!bg-purple-200 hover:!border-purple-200",
    },
    Not_Selected: {
      base: "!bg-red-100 !border-red-100 !text-red-700",
      hover: "hover:!bg-red-200 hover:!border-red-200",
    },
  };
  const tableHeadData = [
    {
      _id: 1,
      name: "Scholarship Title",
      align: "left",
    },
    {
      _id: 2,
      name: "Year",
      align: "left",
    },
    {
      _id: "ApplicationNumber",
      name: "Application Number",
      align: "left",
    },
    {
      _id: "Deadline",
      name: "Deadline",
      align: "left",
    },
    {
      _id: 3,
      name: "Submission Date",
      align: "left",
    },
    {
      _id: 4,
      name: "Status",
      align: "left",
    },
    {
      _id: 5,
      name: " Actions",
      align: "center",
    },
  ];

  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.scholarshipDetails?.title || "N/A",
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.submissionDate
            ? dayjs(item?.submissionDate).format("YYYY")
            : "-",
        },
        {
          _id: "ApplicationNumber",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.applicationNumber || "-",
        },
        {
          _id: "Deadline",
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.deadLine
            ? dayjs(item?.deadLine).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.submissionDate
            ? dayjs(item?.submissionDate).format("DD MMM, YYYY")
            : "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <>
              <Button
                buttonClasses={`!h-8 ${
                  statusStyles[item?.statusDetails?.title]?.base ||
                  "!bg-gray-100 !border-gray-100 !text-gray-700"
                } ${
                  statusStyles[item?.statusDetails?.title]?.hover || ""
                } border rounded-md transition-all duration-200 `}
                buttonLabel={
                  statusText[item?.statusDetails?.title]?.title?.replace(
                    /_/g,
                    " "
                  ) || "-"
                }
                buttonLabelClasses="font-medium !text-sm"
              />
            </>
          ),
        },

        // {
        //   _id: 5,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: (
        //     <span
        //       className="text-red-600 cursor-pointer"
        //       onClick={() =>
        //         setisModalOpen((prev) => ({ ...prev, reminder: true }))
        //       }
        //     >
        //       Send Reminder{" "}
        //     </span>
        //   ),
        // },
        {
          _id: 5,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            item?.statusDetails?.title === "Draft"
              ? {
                  _id: 1,
                  name: "Edit",
                  icon: "fa-regular fa-pen-to-square",
                  onClick: () => {
                    setApplicationModal({
                      isOpen: true,
                      data: item,
                    });
                  },
                  standout: false,
                }
              : {
                  _id: 2,
                  name: "Details",
                  icon: "fa-regular fa-eye",
                  onClick: () => {
                    setViewDetails({
                      isOpen: true,
                      data: item,
                    });
                  },
                  standout: false,
                },
          ],
        },
      ],
    };
  });
  const [isModelOpen, setisModalOpen] = useState({ reminder: false });
  //   console.log("data");
  return (
    <div>
      <h1 className="text-3xl font-bold text-[#C94E53]  px-6 py-4 rounded-2xl text-center ">
        Application List
      </h1>
      <h1 className="text-base font-bold   px-3 py-2 rounded-xl  bg-white mb-2">
        Track the status of your scholarship applications—drafts, submissions,
        —all in one place.
      </h1>
      <div className="flex justify-between my-3 items-center gap-4">
        <div className="w-72 ">
          <Search
            placeholder={"Search here"}
            search={(val) => {
              setKeyword(val);
              handleFilterChange("page", 1, setFilters);
            }}
          />
        </div>
        <div className="text-[#C94E53] text-sm md:text-lg">
          Total Applications: {data?.metadata?.totalDocs || "00"} / Drafts:{" "}
          {data?.metadata?.extraCount?.draft || "00"}
        </div>
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          //   setSelectedItems([]);
        }}
        // isFetching={isFetching}
        isOrderingDisabled={true}
        // selectedItems={selectedItems}
        // setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      <Modal
        isOpen={isModelOpen.reminder}
        setIsOpen={(val) =>
          setisModalOpen((prev) => ({ ...prev, reminder: val }))
        }
        size="lg"
        title={"Send Reminder"}
        titleClass={"!text-chestnut-rose"}
      >
        Your application is incomplete. The final deadline is March 15, 2025.
        Please submit all required documents before the deadline to be
        considered.
        {/* <form onSubmit={(e) => handleSubmit(e, mutate)} className="space-y-6"> */}
        <div className="mt-4">
          <Input
            label={" Email"}
            inputType={"email"}
            // value={values?.email}
            inputPlaceholder={"Enter Your Email"}
            inputName="email"
            // onChange={handleChange}
            required={true}
            isValidate={true}
            // {...formValidate(errors, "email")}
          />
        </div>
        {/* </form> */}
        <div className="flex items-center  gap-4 pt-8 justify-center">
          <div>
            <Button
              buttonLabel={"Sent"}
              buttonLabelClasses={"!text-sm"}
              // buttonIcon={"fa-light fa-floppy-disk"}
              // buttonIconPosition={"left"}
              buttonClasses="!py-3 !px-4 rounded-lg text-white !h-auto !bg-chestnut-rose hover:!bg-red-600 rounded-xl"
              buttonFunction={() => {}}
            />
          </div>
          <div>
            <Button
              buttonLabel={"Close"}
              buttonLabelClasses={"!text-sm"}
              // buttonIcon={"fa-light fa-floppy-disk"}
              // buttonIconPosition={"left "}
              buttonClasses="rounded-xl bg-transparent !text-black border-chestnut-rose border-2 hover:bg-transparent"
              buttonFunction={() =>
                setisModalOpen((prev) => ({ ...prev, reminder: false }))
              }
            />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={isViewDetails?.isOpen}
        setIsOpen={() => setViewDetails({ isOpen: false, data: null })}
        title={"Submission Details" || ""}
        size="xl5"
      >
        <SubmissionDetailsFront
          data={isViewDetails?.data}
          onApply={(data) => {
            setViewDetails({ isOpen: false, data: null });
          }}
          close={() => setViewDetails({ isOpen: false, data: null })}
        />
      </Modal>
      {applicationModal.isOpen && (
        <ApplicationModalFront
          open={applicationModal?.isOpen}
          close={() => {
            setApplicationModal({ isOpen: false, data: null });
            refetch();
          }}
          details={applicationModal.data}
        />
      )}
    </div>
  );
}

export default Applications;
